var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from 'react';
const SvgCheck2Small = _a => {
  var _b, _c, _d;
  var {
      size
    } = _a,
    props = __rest(_a, ["size"]);
  return React.createElement("svg", Object.assign({
    width: size !== null && size !== void 0 ? size : 24,
    height: size !== null && size !== void 0 ? size : 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: props.role,
    "aria-hidden": (_b = props['aria-hidden']) !== null && _b !== void 0 ? _b : true
  }, props), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5669 17.4332C12.0618 17.8715 12.2551 17.7348 12.5285 17.4615L22.795 7.19496C23.0684 6.92159 23.0684 6.47839 22.795 6.20502C22.5216 5.93166 22.0784 5.93166 21.8051 6.20502C21.8051 6.20502 12.9041 15.0221 12.0335 15.9766C11.1629 16.9311 11.0719 16.9948 11.5669 17.4332Z",
    fill: (_c = props.color) !== null && _c !== void 0 ? _c : 'currentColor'
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.19496 11.8049C1.92159 11.5316 1.47839 11.5316 1.20502 11.8049C0.931659 12.0783 0.931659 12.5215 1.20502 12.7949L5.87162 17.4615C6.14499 17.7348 6.58819 17.7348 6.86156 17.4615L17.1281 7.19496C17.4014 6.92159 17.4014 6.47839 17.1281 6.20502C16.8547 5.93166 16.4115 5.93166 16.1381 6.20502L6.36659 15.9766L2.19496 11.8049Z",
    fill: (_d = props.color) !== null && _d !== void 0 ? _d : 'currentColor'
  }));
};
export default SvgCheck2Small;